import { ScanLine, Landmark } from "lucide-react";
import { useCart } from "@/context/CartContext";

const OPTIONS = [
  { id: "qris", icon: ScanLine, title: "QRIS", sub: "Scan dari aplikasi bank / e-wallet", testid: "payment-method-qris" },
  { id: "bank", icon: Landmark, title: "Transfer Bank", sub: "Transfer ke rekening kafe", testid: "payment-method-bank" },
];

export const PaymentOptions = () => {
  const { method, setMethod } = useCart();
  return (
    <div className="space-y-2.5" role="radiogroup">
      {OPTIONS.map(({ id, icon: Icon, title, sub, testid }) => {
        const on = method === id;
        return (
          <button key={id} role="radio" aria-checked={on} onClick={() => setMethod(id)} data-testid={testid}
            className={`w-full flex items-center gap-4 px-4 py-3.5 rounded-xl border-2 text-left transition-colors ${on ? "border-forest bg-paper" : "border-transparent bg-paper/70 hover:border-sage-200"}`}>
            <span className={`w-5 h-5 rounded-full border-2 grid place-items-center ${on ? "border-forest" : "border-ink/30"}`}>
              {on && <span className="w-2.5 h-2.5 rounded-full bg-forest" />}
            </span>
            <Icon className="w-7 h-7 text-ink" strokeWidth={1.6} />
            <span>
              <span className="block font-semibold text-ink">{title}</span>
              <span className="block text-xs text-muted2">{sub}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
};
